import React, { useEffect, useState } from "react";
import PageLoader from "../loader/PageLoader";
import {
    ChatText,
    Checks,
    Copy,
    WarningCircle,
    X,
} from "@phosphor-icons/react";
import axiosInstance from "../../api/axiosInstance";
import dayjs from "dayjs";
import { RejectHotel } from "./RejectAPI";
import {toast} from "react-toastify";
import PromoBreakdown from "./PromoBreakdown";
import { formatHotel } from "../../api/hotelTime";

const Spa = ({ func, selectedRequest }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [remarks, setRemarks] = useState("");
    const [remarksError, setRemarksError] = useState(false);
    
    const [staff, setStaff] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState("");
    const [guestRequestId, setGuestRequestId] = useState("");
    const [spaId, setSpaId] = useState("");
    const [copied, setCopied] = useState(false);
    const [room, setRoom] = useState("");

    // Fetch Data
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/spa-request`,
                    {
                        params: {
                            guest_request_id: selectedRequest.requestId,
                        },
                    },
                );
                const staffResponse = await axiosInstance.get(
                    `api/v1/hotels/${selectedRequest.hotelId}/staff-members`,
                );

                if (response.data?.booked_room_id) {
                    const bookedRoomResponse = await axiosInstance.get(
                        `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${response.data?.booked_room_id}`,
                    );
                    setRoom(bookedRoomResponse.data?.room_number);
                }

                // const bookedRoomResponse = await axiosInstance.get(
                //     `/api/v1/hotels/${selectedRequest.hotelId}/active-booked-rooms`,
                // );

                // console.log(
                //     "---------",
                //     bookedRoomResponse.data.activeBookedRoomsMetadata.filter(
                //         (d) =>
                //             d.booked_room_id === response.data?.booked_room_id,
                //     ),
                // );

                // if (response.data?.booked_room_id) {
                //     const roomNumber =
                //         bookedRoomResponse.data.activeBookedRoomsMetadata.filter(
                //             (d) =>
                //                 d.booked_room_id ===
                //                 response.data?.booked_room_id,
                //         );
                //     setRoom(roomNumber[0].room_no);
                // }
                setSpaId(response.data?.id);
                setStaff(staffResponse.data.data);
                setData(response.data);
                setRemarks(response.data?.remarks);
                setGuestRequestId(response.data?.guest_request_id);
                setLoading(false);
            } catch (err) {
                setErrors({ fetch: "Failed to fetch Housekeeping data" });
                setLoading(false);
            }
        };
        fetchData();
    }, [selectedRequest]);

    // console.log("--------", selectedRequest.bookingId);

    // console.log("Spa Data  : ",data);


    // Staff is picked once: reassigning is only offered while nobody holds the request
    // or the assigned member has declined, so an accepted request cannot be silently
    // handed to someone else.
    const canAssignStaff = !data?.staff_member_id || data?.staff_status === "StaffDeclined";

    // Fall back to the staff list this modal already loaded, so the assigned name still
    // shows when the request payload carries only the id.
    const assignedStaffName =
        data?.staff_name ||
        staff.find((member) => member.id === data?.staff_member_id)?.name ||
        "";

    const { preferred_time } = data || "";
    const inData = formatHotel(preferred_time, "DD MMMM YYYY");
    const inTime = formatHotel(preferred_time, "hh:mm A");

    // Handle Reject Request
    const handleRejectRequest = async () => {
        try {
            if(remarks.trim()==="") {
                setRemarksError(true);
                return;
            }
            const request = {
                hotelId: selectedRequest.hotelId,
                bookingId: selectedRequest.bookingId,
                guestRequestId: guestRequestId,
            };
            const response = await RejectHotel(request,remarks);
            if (response) func(false);
        } catch (error) {
            setErrors({ fetch: "Failed to reject Housekeeping request" });
            console.log(error);
        }
    };

    // Handle Respond to Guest
    const handleRespondToGuest = async () => {
        try {
            if (!selectedStaff) {
                setErrors({ staff: "Please select the staff member" });
                return;
            }
            setErrors({
                fetch: "",
            });
            const response = await axiosInstance.put(
                `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/spa-request/${spaId}`,
                {
                    staff_member_id: selectedStaff,
                    remarks: remarks,
                },
            );
            func(false);
        } catch (error) {
            setErrors({ fetch: "Failed to update Housekeeping status" });
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
        });
    };


    // Complete Hotel 
    const handleCompleteHotel = async()=>{
        try{
 
            const response = await axiosInstance.put(
                `/api/v1/hotels/${selectedRequest.hotelId}/guest-requests/${guestRequestId}/status`,
                {
                    status: "Completed_Hotel",
                    remarks: remarks,
                },
            );
            toast.success("Spa Request Completed");
            if (response) func(false);
        }catch(error){
            console.log(error);
            toast.error(error?.response?.data?.message || "Some Error Occured");
        }
    }

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            {loading && <PageLoader />}
            <form
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
                onSubmit={(e) => e.preventDefault()}
            >
                {/* Header */}
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">Spa Orders</h2>
                    <button
                        onClick={() => func(false)}
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>{" "}

                {/* Booking Details */}
                <div className="flex items-center justify-between gap-2 mb-1">
                    <div className="w-1/4">
                        <p className="text-[#8C9199] mb-2">Room Number</p>
                        <div className="flex items-center gap-2 w-[90%]">
                            <p className="truncate">{room}</p>
                            {/* <button
                                onClick={() => handleCopy(data?.booked_room_id)}
                                className="text-gray-500 hover:text-blue-500"
                                title="Copy to clipboard"
                            >
                                {copied ? (
                                    <Checks size={16} />
                                ) : (
                                    <Copy size={16} />
                                )}
                            </button> */}
                        </div>
                    </div>

                    <div className="w-1/4">
                        <p className="text-[#8C9199] mb-2">Requested Time</p>
                        <p>{inData}</p>
                    </div>
                    <div className="w-1/4">
                        <p className="text-[#8C9199] mb-2">Requested Date</p>
                        <p>{inTime}</p>
                    </div>
                </div>

                {/* Service Name */}
                <div>
                    <p className="text-[#8C9199] mb-1">Massage Type</p>
                    {/* <p>Swedish Relaxation Massage x (1pax)</p> */}
                    <p>
                        {data?.spa_service_name} x ({data?.number_of_people}pax)
                    </p>
                </div>
                
                <PromoBreakdown
                    grossAmount={data?.total_amount}
                    discountAmount={data?.discount_amount}
                    promotionId={data?.promotion_id}
                />

                {/* Comments */}
                <div>
                    <p className="mb-1 text-[#8C9199]">Note</p>
                    <p className="flex items-center gap-2 bg-yellow-100 p-1.5 rounded-md text-yellow-700 text-sm">
                        <ChatText size={16} weight="bold" />
                        {data?.additional_comments}
                    </p>
                </div>

                {/* Staff Assigning */}
                <div>
                    <p className=" mb-1 text-[#8C9199]">Assigned Staff</p>
                    <select
                        name="staff"
                        id="staff"
                        className="border-[1.5px] rounded-md p-1.5 disabled:bg-[#F2F7FF] disabled:text-[#8C9199]"
                        disabled={!canAssignStaff}
                        onChange={(e) => {
                            setSelectedStaff(e.target.value);
                            setErrors({ staff: "" });
                        }}
                    >
                        {canAssignStaff ? (
                            <>
                                <option value="">Select the staff</option>
                                {staff.map((d) => (
                                    <option key={d.id} value={d.id}>
                                        {d.name} - {d.department} dept.
                                    </option>
                                ))}
                            </>
                        ) : (
                            <option
                                key={data?.staff_member_id}
                                value={data?.staff_member_id}
                            >
                                {assignedStaffName}
                            </option>
                        )}
                    </select>
                    {errors.staff && (
                        <p className="text-[#ff7378] text-[12px] flex items-center gap-1 p-0.5">
                            <WarningCircle />
                            {errors.staff}
                        </p>
                    )}
                </div>{" "}
                
                {/* Remarks */}
                <div>
                    <p className="border-[1.px] text-[#8C9199] mb-1">Remarks</p>
                    <textarea
                        rows={4}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:border-blue-400"
                        placeholder="Mention your comment here"
                        value={remarks}
                        onChange={(e)=>{
                            const value = e.target.value;
                            setRemarks(value);
                            setRemarksError(false);
                        }}
                    ></textarea>
                    {remarksError && (
                        <p className="text-[#ff7378] flex gap-1 items-center text-xs mt-1">
                            <WarningCircle size={14} />
                            remarks is required when you reject the request
                        </p>
                    )}
                </div>
                
                {/* Buttons */}
                <div className={`grid ${canAssignStaff ? "grid-cols-3" : "grid-cols-2"} gap-3 mt-2`}>
                    {canAssignStaff && (
                        <button
                            className="p-2 w-full bg-[#ff7378] rounded-md font-medium hover:bg-[#f75f64] transition duration-150 outline-none"
                            type="button"
                            onClick={handleRespondToGuest}
                        >
                            Assign Staff
                        </button>
                    )}

                    <button className="p-2 w-full border-[1.5px] bg-[#73c9ff] rounded-md font-medium hover:bg-[#5fa4f7] transition duration-150 outline-none" onClick={()=>handleCompleteHotel()} >
                        Complete Request
                    </button>

                    <button
                        className="p-2 w-full border-[1.5px] border-red-300 text-[#ff7378] rounded-md font-medium hover:bg-red-50 transition duration-150 outline-none"
                        type="button"
                        onClick={handleRejectRequest}
                    >
                        Reject Request
                    </button>

                </div>

                {errors.fetch && <p className="text-red-500">{errors.fetch}</p>}
                {errors.reject && (
                    <p className="text-red-500">{errors.reject}</p>
                )}
                {
                    data?.staff_status==="StaffDeclined" && <span className="text-red-500">
                    The staff has declined the request. Please select another staff member
                    </span>
                }
            </form>
        </div>
    );
};

export default Spa;
